const map = {
  programmato: { label: "Programmato", cls: "bg-sky-50 text-sky-700 border-sky-200" },
  in_corso: { label: "In Corso", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  completato: { label: "Completato", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  annullato: { label: "Annullato", cls: "bg-rose-50 text-rose-700 border-rose-200" },
};

export default function StatusBadge({ status }) {
  const s = map[status] || map.programmato;
  return (
    <span
      data-testid="job-status-badge"
      className={`inline-flex items-center text-[11px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full border ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
